
        var result = require("!!../../../../node_modules/css-loader/index.js!./treatment-price-change.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/treatment-price-change.component.css
// module id = 2367
// module chunks = 1